import { UPDATE_SPEAKERDATA, GET_SPEAKER_LIST } from '../constant';
import { getSpeakerDataApi, updateSpeakerDataApi } from '../../api';

export const getSpeakerDatas = (data) => ({
	type: GET_SPEAKER_LIST,
	data,
});

export const updateSpeakerData = (data) => ({
	type: UPDATE_SPEAKERDATA,
	data,
});

export const getSpeakerDatasAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getSpeakerDataApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					const totalCount = (data.value as any)?.total;
					console.log("totalCount",totalCount)
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					dispatch(
						getSpeakerDatas({ data: (data.value as any)?.data ?? [], total: totalpage })
					//	getSpeakerDatas({ data: (data.value as any), total: totalpage })
					);
					console.log("dispatch",data);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const updateSpeakerDataAsync = (data) => async (dispatch) => {
	try {
		const response = await updateSpeakerDataApi(data);
		if (response.errorCode.trim().length === 0) {
			console.log(':::::::::::updateSpeakerDataAsync', response.value);
			dispatch(updateSpeakerData(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
